import { createAction, props } from '@ngrx/store';

import { Schedule } from 'src/app/model/schedule';


export const getSchedules = createAction('GET_SCHEDULES', props<{ siteId: number }>());
export const getSchedulesSuccess = createAction('GET_SCHEDULES_SUCCESS', props<{ schedules: Schedule[] }>());
export const getSchedulesFailed = createAction('GET_SCHEDULES_FAILED', props<{ errorMessage: string }>());

export const resetScheduleDialog = createAction('RESET_SCHEDULE_DIALOG');
export const addSchedule = createAction('ADD_SCHEDULE', props<{ schedule: Schedule }>());
export const addScheduleSuccess = createAction('ADD_SCHEDULE_SUCCESS', props<{ message: string; schedule: Schedule }>());
export const addScheduleFailed = createAction('ADD_SCHEDULE_FAILED', props<{ errorMessage: string }>());

export const editSchedule = createAction('EDIT_SCHEDULE', props<{ schedule: Schedule }>());
export const editScheduleSuccess = createAction('EDIT_SCHEDULE_SUCCESS', props<{ message: string; schedule: Schedule }>());
export const editScheduleFailed = createAction('EDIT_SCHEDULE_FAILED', props<{ errorMessage: string }>());

export const deleteSchedule = createAction('DELETE_SCHEDULE', props<{ scheduleId: number }>());
export const deleteScheduleSuccess = createAction('DELETE_SCHEDULE_SUCCESS', props<{ message: string; scheduleId: number }>());
export const deleteScheduleFailed = createAction('DELETE_SCHEDULE_FAILED', props<{ errorMessage: string }>());
